import React from "react";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

const CardComponent = ({ heading, content, Icon, redirectTo, date }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate(redirectTo, { state: date });
  };

  return (
    <Container sx={{ marginTop: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: "30px",
          padding: "10px",
          // border: "2px solid #ddd",
          flexDirection: "row",
          textAlign: "left",
          cursor: "pointer",
        }}
        className="container_bg"
        onClick={handleNavigation}
      >
        {/* <Icon
          sx={{
            marginRight: 2,
            marginBottom: 0,
          }}
          className="icons"
        /> */}

        <Box component="img" src={Icon} alt="Icon" className="icons" />

        <Box>
          <Typography variant="h6" className="typography_heading head">
            {heading}
          </Typography>
          <Typography variant="body1" className="content_body">
            {content}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default CardComponent;
